<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-main style="padding-top:0rem;">
      <div class="zj-layout-main-content scrollable">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem" style="width: 118rem;">
        <el-form-item label="预案名称" prop="planName">
          <el-input v-model="ruleForm.planName" style="width:98rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="预案编号" style="display:inline-block;" prop="planNo">
          <el-input v-model="ruleForm.planNo" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="预案版本号" style="display:inline-block;" prop="planVersion">
          <el-input v-model="ruleForm.planVersion" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
        <el-form-item label="预案应对等级" style="display:inline-block;" prop="planLevel">
          <el-select
            v-model="ruleForm.planLevel"
            placeholder="请选择预案应对等级"
            v-bind:disabled="IsEdit"
            style="width:40rem;"
          >
            <el-option
              v-for="item in options"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预案属性" style="display:inline-block;" prop="planAttribute">
          <el-select
            v-model="ruleForm.planAttribute"
            style="width:40rem;"
            placeholder="请选择预案属性"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in options1"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预案类型" style="display:inline-block;" prop="planType">
          <el-select
            v-model="ruleForm.planType"
            style="width:40rem;"
            placeholder="请选择预案类型"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in options2"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否备案" style="display:inline-block;" prop="icpFlag">
          <el-select
            v-model="ruleForm.icpFlag"
            style="width:40rem;"
            placeholder="请选择是否备案"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in options3"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用事件类型" style="display:inline-block;" prop="applicableEvent">
          <el-select
            style="width:40rem;"
            v-model="ruleForm.applicableEvent"
            placeholder="请选择预案类型"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in options4"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预案备案编号" style="display:inline-block;" prop="icpNo">
          <el-input
            v-model="ruleForm.icpNo"
            style="width:40rem;"
            maxlength="50"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期" style="display:inline-block;" prop="publishDate">
          <el-date-picker
            type="date"
            style="width:40rem;"
            placeholder="选择日期"
            v-model="ruleForm.publishDate"
            v-bind:disabled="IsEdit"
            format="yyyy-MM-dd" 
            value-format="yyyy-MM-dd 00:00:00"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预案备案时间" style="display:inline-block;" prop="icpDate">
          <el-date-picker
            placeholder="选择日期"
            style="width:40rem;"
            v-model="ruleForm.icpDate"
            v-bind:disabled="IsEdit"
            format="yyyy-MM-dd" 
            value-format="yyyy-MM-dd 00:00:00"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="制定人" style="display:inline-block;" prop="preparedBy">
          <el-input
            v-model="ruleForm.preparedBy"
            style="width:40rem;"
            maxlength="50"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
        <el-form-item label="预案状态" style="display:inline-block;" prop="planStatus">
          <el-select
            style="width:40rem;"
            v-model="ruleForm.planStatus"
            placeholder="请选择预案状态"
            v-bind:disabled="IsEdit"
          >
            <el-option
              v-for="item in options5"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用范围描述" prop="scopeDesc">
          <el-input
            type="textarea"
            style="width:98rem;"
            v-model="ruleForm.scopeDesc"
            maxlength="1000"
            v-bind:disabled="IsEdit"
          ></el-input>
        </el-form-item>
      </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer style="padding-bottom: 0rem;">
      <div style="text-align:center;width:134rem;padding:0rem 0rem;">
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">提交</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
import ZJUser from "@/user";
const utils = ZJApp.ZJUtils;
import { getDictionary } from "@/api/src/emergency_common";
import { save, update, detail } from "@/api/src/emergency_plan";
export default {
  name: "ZjPlanDetail",
  controller: "UI",
  action: "PlanDetail",
  props: {
    query: {
      type: String,
      id: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      ruleForm: {
        planName: "",
        planNo: "",
        planVersion: "",
        planLevel: null,
        planAttribute: null,
        planType: null,
        icpFlag: null,
        applicableEvent: null,
        icpNo: "",
        publishDate: "",
        icpDate: "",
        preparedBy: ZJUser.current.UserName,
        planStatus: null,
        scopeDesc: "",
      },
      options2: [],
      options4: [],
      options: [],
      options5: [],
      options1: [],
      options3: [],
      rules: {
        planName: [
          { required: true, message: "请输入预案名称", trigger: "blur" },
          { min: 1, max: 200, message: "最多输入200个字符", trigger: "blur" }
        ],
        planNo: [
          { required: true, message: "请输入预案编号", trigger: "blur" },
          { min: 1, max: 50, message: "最多输入50个字符", trigger: "blur" }
        ],
        planVersion: [
          { required: true, message: "请输入预案版本号", trigger: "blur" },
          { min: 1, max: 30, message: "最多输入30个字符", trigger: "blur" }
        ],
        planLevel: [
          { required: true, message: "请选择预案级别", trigger: "change" }
        ],
        planAttribute: [
          { required: true, message: "请选择预案属性", trigger: "change" }
        ],
        planType: [
          { required: true, message: "请选择预案类型", trigger: "change" }
        ],
        applicableEvent: [
          { required: true, message: "请选择适用事件类型", trigger: "change" }
        ],
        planStatus: [
          { required: true, message: "请选择预案状态", trigger: "change" }
        ],
        publishDate: [
          {
            //type: "date",
            required: true,
            message: "请选择发布日期",
            trigger: "change"
          }
        ],
        icpDate: [
          {
            //type: "date",
            required: true,
            message: "请选择预案备案时间",
            trigger: "change"
          }
        ],
        IsEdit: false
      }
    };
  },
  created: function() {
    this.basedatabind()
    .then(()=>{
      this.search();
    });
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          planName: "",
          planNo: "",
          planVersion: "",
          planLevel: null,
          planAttribute: null,
          planType: null,
          icpFlag: null,
          applicableEvent: null,
          icpNo: "",
          publishDate: "",
          icpDate: "",
          preparedBy: ZJUser.current.UserName,
          planStatus: null,
          scopeDesc: "",
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';

      this.ruleForm.preparedBy = ZJUser.current.UserName;

      return utils.waitAll([
        getDictionary('emergency_plan_type'), //预案类型
        getDictionary('emergency_applicable_event'),//适用事件类型
        getDictionary('emergency_plan_level'), //应对等级
        getDictionary('emergency_plan_status'),//预案状态
        getDictionary('emergency_plan_attribute'),//预案状态
        getDictionary('yes_no'),//预案状态
      ])
      .then(r => {

        this.options2 = r[0].data.records;
        this.options4 = r[1].data.records;
        this.options = r[2].data.records;
        this.options5 = r[3].data.records;
        this.options1 = r[4].data.records;
        this.options3 = r[5].data.records;
        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });
    },
    search() {
      let { id } = this.query;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = '加载中...';
        detail( id )
          .then(r => {
            var data = r.data;
            if (data) {
              this.ruleForm = data;
            }
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.query.id == null || this.query.id == "") {
            this.loading = true;
            this.loadingText = '保存中...';
            save(this.ruleForm)
              .then(r => {
                r = r.data;              
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！"
                });
                this.$router.go(-1); //返回上一层
              })
              .catch(e => {
                console.error(e);
                this.loading = false;
              });
          } else {
            this.loading = true;
            this.loadingText = '保存中...';
            update(this.ruleForm)
              .then(r => {
                r = r.data;
                this.$message({
                  type: "success",
                  message: r ? "保存成功！" : "保存失败！"
                });
                this.loading = false;
                this.$emit("ChangeTab", "second");
              })
              .catch(e => {
                console.error(e);
                this.loading = false;
              });
          }
        } else {
          console.error("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>